// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/iminio_logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/CERCHI LOGIN IMINIO (1).svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/CERCHI LOGIN IMINIO.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    /* background: rgb(221,221,221); */
    height: 100vh;
    /* background: var(--clr-orange-base); */
  }

#login-form-title-i{
    font-size: 3.3rem;
}
#login-form-title{
    font-size: 3rem;
}

.sing-in-floating-container{
    position: fixed;
    z-index: 20;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 480px !important;
    border-radius: 25px;
}

#sing-in-error-container{
    border-radius: 25px
}

#iminio-logo-login{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 100px;
    width: 300px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    top: 0px;
    left: 0px;
    z-index: -1;
    filter: brightness(1.1);
}

#floating-decoration-bottom-left{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 0 0 repeat;
    height: 500px;
    width: 500px;
    background-size: contain;
    background-repeat: no-repeat;
    position: fixed;
    bottom: -60px;
    left: 0px;
    transform: translate(-25%, 25%);
    animation-name: decoration-anim-clockwise;
    animation-duration: 17s;
    animation-iteration-count: infinite;
}

#floating-decoration-top-right{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 500px;
    width: 500px;
    background-size: contain;
    background-repeat: no-repeat;
    position: fixed;
    top: 0px;
    right: 0px;
    transform: translate(25%, -33%);
    animation-name: decoration-anim-counterclockwise;
    animation-duration: 17s;
    animation-iteration-count: infinite;
}

#floating-decoration-bottom-right{
    position: fixed;
    bottom: 0px;
    right: 20px;
    display: flex;
    flex-direction: column;
}
#float-decoration-bottom-right-dot{
    transform: translate(0px, 50%);
}

#floating-version-text{
    position: fixed;
    bottom: 0px;
    right: 7px;
    font-size: 0.7rem;
    color: #fff;
    opacity: 70%;
}

@keyframes decoration-anim-clockwise {
    0% {
        transform: translate(-25%, 25%) scale(0.9) rotate(-13deg);
    }
    50% {
        transform: translate(-25%, 25%) scale(1.1) rotate(13deg);
    }
    100% {
        transform: translate(-25%, 25%) scale(0.9) rotate(-13deg);
    }
  }

  @keyframes decoration-anim-counterclockwise {
    0% {
        transform: translate(25%, -33%) scale(0.9) rotate(13deg);
    }
    50% {
        transform: translate(25%, -33%) scale(1.1) rotate(-13deg);
    }
    100% {
        transform: translate(25%, -33%) scale(0.9) rotate(13deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,aAAa;IACb,wCAAwC;EAC1C;;AAEF;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,mDAA8C;IAC9C,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,4BAA4B;IAC5B,QAAQ;IACR,SAAS;IACT,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,8DAA0E;IAC1E,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;IACf,aAAa;IACb,SAAS;IACT,+BAA+B;IAC/B,yCAAyC;IACzC,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,mDAAwD;IACxD,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;IAC5B,eAAe;IACf,QAAQ;IACR,UAAU;IACV,+BAA+B;IAC/B,gDAAgD;IAChD,uBAAuB;IACvB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,yDAAyD;IAC7D;IACA;QACI,wDAAwD;IAC5D;IACA;QACI,yDAAyD;IAC7D;EACF;;EAEA;IACE;QACI,wDAAwD;IAC5D;IACA;QACI,yDAAyD;IAC7D;IACA;QACI,wDAAwD;IAC5D;EACF","sourcesContent":["body{\n    /* background: rgb(221,221,221); */\n    height: 100vh;\n    /* background: var(--clr-orange-base); */\n  }\n\n#login-form-title-i{\n    font-size: 3.3rem;\n}\n#login-form-title{\n    font-size: 3rem;\n}\n\n.sing-in-floating-container{\n    position: fixed;\n    z-index: 20;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 480px !important;\n    border-radius: 25px;\n}\n\n#sing-in-error-container{\n    border-radius: 25px\n}\n\n#iminio-logo-login{\n    background: url(\"/public/img/iminio_logo.png\");\n    height: 100px;\n    width: 300px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n    top: 0px;\n    left: 0px;\n    z-index: -1;\n    filter: brightness(1.1);\n}\n\n#floating-decoration-bottom-left{\n    background: url(\"/public/img/CERCHI\\ LOGIN\\ IMINIO\\ \\(1\\).svg\") 0 0 repeat;\n    height: 500px;\n    width: 500px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    position: fixed;\n    bottom: -60px;\n    left: 0px;\n    transform: translate(-25%, 25%);\n    animation-name: decoration-anim-clockwise;\n    animation-duration: 17s;\n    animation-iteration-count: infinite;\n}\n\n#floating-decoration-top-right{\n    background: url(\"/public/img/CERCHI\\ LOGIN\\ IMINIO.svg\");\n    height: 500px;\n    width: 500px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    position: fixed;\n    top: 0px;\n    right: 0px;\n    transform: translate(25%, -33%);\n    animation-name: decoration-anim-counterclockwise;\n    animation-duration: 17s;\n    animation-iteration-count: infinite;\n}\n\n#floating-decoration-bottom-right{\n    position: fixed;\n    bottom: 0px;\n    right: 20px;\n    display: flex;\n    flex-direction: column;\n}\n#float-decoration-bottom-right-dot{\n    transform: translate(0px, 50%);\n}\n\n#floating-version-text{\n    position: fixed;\n    bottom: 0px;\n    right: 7px;\n    font-size: 0.7rem;\n    color: #fff;\n    opacity: 70%;\n}\n\n@keyframes decoration-anim-clockwise {\n    0% {\n        transform: translate(-25%, 25%) scale(0.9) rotate(-13deg);\n    }\n    50% {\n        transform: translate(-25%, 25%) scale(1.1) rotate(13deg);\n    }\n    100% {\n        transform: translate(-25%, 25%) scale(0.9) rotate(-13deg);\n    }\n  }\n\n  @keyframes decoration-anim-counterclockwise {\n    0% {\n        transform: translate(25%, -33%) scale(0.9) rotate(13deg);\n    }\n    50% {\n        transform: translate(25%, -33%) scale(1.1) rotate(-13deg);\n    }\n    100% {\n        transform: translate(25%, -33%) scale(0.9) rotate(13deg);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
